export default __webpack_public_path__ + "static/media/bg-pick-left.1ca7067a.png";